export const Role = {
    User: {
        id: 3,
        name: "一般",
    },
    Cooperator: {
        id: 4,
        name: "派遣添乗員",
    },
    Admin: {
        id: 2,
        name: "管理者",
    },
    SysAdmin: {
        id: 1,
        name: "システム管理者",
    },
    PwReset: {
        id: 5,
        name: "パスワードリセット",
    },
    ReadOnly: {
        id: 6,
        name: "参照限定",
    },
};



// WEBPACK FOOTER //
// ./src/helpers/role.js